import { generateId } from '@freelancer/datastore/testing/helpers';
import type { CustomerWebhook } from './customer-webhooks.model';

export interface GenerateCustomerWebhookOptions {
  readonly id?: number;
  readonly url: string;
}

export function generateCustomerWebhookObject({
  url,
}: GenerateCustomerWebhookOptions): CustomerWebhook {
  return {
    id: generateId(),
    url,
  };
}
